import React from 'react';
const IMAGE_URL = process.env.REACT_APP_IMAGE_URL

export default (params) => (
    <span className="imgSpanLogo">
        {params.value && (
            <img
                alt={`${params.value} `}
                src={`${IMAGE_URL}/${params.value}`}
                style={{ width: "90px" }}
            />
        )}
    </span>
);